import { PageType } from '../../common/page-types'
import { AdURI, AdURIFormatter } from './uri'

/**
 * This forms the equivalent of a page identifier for requests to an ad service.
 *
 * @param account
 * @param site
 * @param categories
 */
export const defaultAdURIFormatter: AdURIFormatter = (
    account: string,
    site: string,
    ancestry?: string[],
    type?: PageType): string => {

    return new AdURI(account)
        .add(site)

        // if page-data contains ancestry then include in URI except in some cases
        .addIf(type !== PageType.AUTHOR, [...ancestry || []])

        // remove the author slug from the URI
        .addIf(type === PageType.AUTHOR, [...ancestry || []].slice(0, -1))

        // suffix
        .add(type === PageType.STORY ? PageType.STORY : PageType.INDEX)

        .toString()
    }
